import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import DropDownInput from '../Input/dropDownInput/dropDownInput';
import ConstantInput from '../Input/constantInput/constantInput';

const statusOptions = [
  { id: '', name: 'All' },
  { id: '1', name: 'Active' },
  { id: '0', name: 'Inactive' },
];

const INITIAL_FILTER = {
  status: '',
  project_id: '',
};

const DynamicContentsFilter = ({ applyFilter, listFilterData }) => {
  const appliedValues = listFilterData?.appliedFilterValues;
  const [filterFieldsData, setFilterFieldsData] = useState(INITIAL_FILTER);

  useEffect(() => {
    if (appliedValues) {
      setFilterFieldsData({
        status: appliedValues.status ?? '',
        project_id: appliedValues.project_id ?? '',
      });
    } else {
      setFilterFieldsData(INITIAL_FILTER);
    }
  }, [appliedValues?.status, appliedValues?.project_id]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.projectId}
        value={filterFieldsData.project_id}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData((prev) => ({ ...prev, project_id: val }))
        }
      />
      <DropDownInput
        label={localization.status}
        data={statusOptions}
        value={
          filterFieldsData.status !== '' && filterFieldsData.status != null
            ? statusOptions.find((o) => String(o.id) === String(filterFieldsData.status))?.name
            : ''
        }
        getIdValue={(val) =>
          setFilterFieldsData((prev) => ({ ...prev, status: val?.id ?? '' }))
        }
      />
      <br />
      <br />
      <div className="btn-wrapper">
        <button type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(INITIAL_FILTER);
            applyFilter(INITIAL_FILTER);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

DynamicContentsFilter.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  listFilterData: PropTypes.shape({
    appliedFilterValues: PropTypes.object,
  }),
};

DynamicContentsFilter.defaultProps = {
  listFilterData: null,
};

export default DynamicContentsFilter;
